import { Routes } from '@angular/router';
import { InstagramAuthenticationComponent } from './instagram-authentication/instagram-authentication.component';
import { RequestComponent } from './request/request.component';
import { PortalsResolveService } from './core/services/portals.resolve.service';
import { FacebookAuthenticationComponent } from './facebook-authentication/facebook-authentication.component';
import { YoutubeAuthenticationComponent } from './youtube-authentication/youtube-authentication.component';
import { NotFoundPageComponent } from '@sb-tools/typescript/components/error-pages/not-found-page/not-found-page.component';

export const routes: Routes = [
    { path: 'instagramOAuth', component: InstagramAuthenticationComponent },
    { path: 'facebookOAuth', component: FacebookAuthenticationComponent },
    { path: 'youtubeOAuth', component: YoutubeAuthenticationComponent },
    {
        path: ':portalName',
        component: RequestComponent,
        resolve: {
            initData: PortalsResolveService,
        },
    },
    { path: '**', component: NotFoundPageComponent },
];
